import React, { useState } from "react"
import addToMailchimp from "gatsby-plugin-mailchimp"

const message = {
  "en-us":
    "Thank you! Please check your inbox to confirm the subscription to the MoBerries newsletter.",
  "de-de":
    "Vielen Dank! Bitte überprüfen Sie Ihren Posteingang, um das Abonnement des MoBerries-Newsletters zu bestätigen.",
}
const SubscribeBlog = ({ home, locale }) => {
  if (!home) {
    return null
  }
  const [email, setEmail] = useState("")
  const [result, setResult] = useState("")
  const {
    subscribe_button,
    subscribe_image,
    subscribe_text,
    subscribe_title,
  } = home
  const handleSubmit = async e => {
    e.preventDefault()
    const result = await addToMailchimp(email)
    setResult(result.result)
  }
  return (
    <section className="py-7">
      <div className="container">
        {result === "success" ? (
          <p>{message[locale]}</p>
        ) : (
          <div className="row align-items-center">
            <div className="d-none d-lg-block col-lg-5">
              <img
                alt="cover blog post"
                className="img-fluid"
                src={subscribe_image.url}
              />
            </div>
            <div className="col-lg-6 offset-lg-1">
              <h3 className="section-title">{subscribe_title}</h3>
              <p className="mb-3">{subscribe_text}</p>
              <div className="row no-guters">
                <div className="col-md-10">
                  <form onSubmit={e => handleSubmit(e)}>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="you@example.com"
                        aria-label="Mail Adress"
                        onChange={e => setEmail(e.target.value)}
                        value={email}
                      />
                      <div className="input-group-append">
                        <button
                          className="btn btn-blog text-uppercase"
                          type="submit"
                          id="button-addon2"
                        >
                          {subscribe_button}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default SubscribeBlog
